import { DomainError } from "@/entities/error.ts";
import { BaseActie } from "@/entities/actie";

export class ActieDtoTransformatieError extends DomainError {
    protected constructor(type: BaseActie["type"], wijzigingType: BaseActie["wijzigingType"], reason: string) {
        super(`Kon geen ${type}${wijzigingType}Actie maken van DTO omdat ${reason}`);
    }

    public static nietOndersteundWijzigingTypeVoorActie(type: BaseActie["type"], wijzigingType: BaseActie["wijzigingType"]): DomainError {
        return new ActieDtoTransformatieError(type, wijzigingType, `${wijzigingType} (nog) niet ondersteund wijzigingType is voor ${type}`);
    }

    public static prognose(wijzigingType: BaseActie["wijzigingType"], reason: string): ActieDtoTransformatieError {
        return new ActieDtoTransformatieError("Prognose", wijzigingType, reason);
    }

    public static opstartplan(wijzigingType: BaseActie["wijzigingType"], reason: string): ActieDtoTransformatieError {
        return new ActieDtoTransformatieError("Opstartplan", wijzigingType, reason);
    }
}
